/**
 * This file is generated by tools/generateLazyLoadedIconModule.ts. It has
 * a conditional for every possible file path for lazy loaded icons so that
 * Parcel knows how to bundle the icons properly.
 */
/* eslint-disable max-lines */
/* eslint-disable complexity */
export default function loadIcon(type: string, name: string): any {
  if (type === 'brand' && name === 'jupiterone/class/AccessKey') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/AccessKey');
  }

  if (type === 'brand' && name === 'jupiterone/class/AccessPolicy') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/AccessPolicy'
    );
  }

  if (type === 'feather' && name === 'bookmark') {
    return import('react-feather/dist/icons/bookmark');
  }

  if (type === 'feather' && name === 'pocket') {
    return import('react-feather/dist/icons/pocket');
  }

  if (type === 'brand' && name === 'jupiterone/class/AdminUser') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/AdminUser');
  }

  if (type === 'feather' && name === 'box') {
    return import('react-feather/dist/icons/box');
  }

  if (type === 'brand' && name === 'jupiterone/class/ApplicationEndpoint') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/ApplicationEndpoint'
    );
  }

  if (type === 'feather' && name === 'copy') {
    return import('react-feather/dist/icons/copy');
  }

  if (type === 'feather' && name === 'code') {
    return import('react-feather/dist/icons/code');
  }

  if (type === 'brand' && name === 'jupiterone/radar') {
    return import('@jupiterone/react-brand-icons/jupiterone/radar');
  }

  if (type === 'feather' && name === 'meh') {
    return import('react-feather/dist/icons/meh');
  }

  if (type === 'brand' && name === 'jupiterone/clock-rewind') {
    return import('@jupiterone/react-brand-icons/jupiterone/clock-rewind');
  }

  if (type === 'feather' && name === 'award') {
    return import('react-feather/dist/icons/award');
  }

  if (type === 'feather' && name === 'hash') {
    return import('react-feather/dist/icons/hash');
  }

  if (type === 'feather' && name === 'crosshair') {
    return import('react-feather/dist/icons/crosshair');
  }

  if (type === 'feather' && name === 'server') {
    return import('react-feather/dist/icons/server');
  }

  if (type === 'feather' && name === 'git-commit') {
    return import('react-feather/dist/icons/git-commit');
  }

  if (type === 'brand' && name === 'jupiterone/class/CodeDeploy') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/CodeDeploy');
  }

  if (type === 'feather' && name === 'git-merge') {
    return import('react-feather/dist/icons/git-merge');
  }

  if (type === 'feather' && name === 'package') {
    return import('react-feather/dist/icons/package');
  }

  if (type === 'feather' && name === 'code') {
    return import('react-feather/dist/icons/code');
  }

  if (type === 'brand' && name === 'jupiterone/class/CodeReview') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/CodeReview');
  }

  if (type === 'feather' && name === 'layout') {
    return import('react-feather/dist/icons/layout');
  }

  if (type === 'brand' && name === 'jupiterone/class/Container') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Container');
  }

  if (type === 'feather' && name === 'sliders') {
    return import('react-feather/dist/icons/sliders');
  }

  if (type === 'brand' && name === 'jupiterone/class/ControlPolicy') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/ControlPolicy'
    );
  }

  if (type === 'brand' && name === 'jupiterone/class/Computer') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Computer');
  }

  if (type === 'brand' && name === 'jupiterone/class/CryptoKey') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/CryptoKey');
  }

  if (type === 'feather' && name === 'database') {
    return import('react-feather/dist/icons/database');
  }

  if (type === 'feather' && name === 'disc') {
    return import('react-feather/dist/icons/disc');
  }

  if (type === 'feather' && name === 'archive') {
    return import('react-feather/dist/icons/archive');
  }

  if (type === 'brand' && name === 'jupiterone/class/CodeDeploy') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/CodeDeploy');
  }

  if (type === 'feather' && name === 'tablet') {
    return import('react-feather/dist/icons/tablet');
  }

  if (type === 'feather' && name === 'book') {
    return import('react-feather/dist/icons/book');
  }

  if (type === 'feather' && name === 'hard-drive') {
    return import('react-feather/dist/icons/hard-drive');
  }

  if (type === 'feather' && name === 'file') {
    return import('react-feather/dist/icons/file');
  }

  if (type === 'brand' && name === 'jupiterone/class/Domain') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Domain');
  }

  if (type === 'brand' && name === 'jupiterone/class/DomainRecord') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/DomainRecord'
    );
  }

  if (type === 'brand' && name === 'jupiterone/class/DomainZone') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/DomainZone');
  }

  if (type === 'feather' && name === 'flag') {
    return import('react-feather/dist/icons/flag');
  }

  if (type === 'feather' && name === 'shield') {
    return import('react-feather/dist/icons/shield');
  }

  if (type === 'feather' && name === 'map') {
    return import('react-feather/dist/icons/map');
  }

  if (type === 'brand' && name === 'jupiterone/class/Function') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Function');
  }

  if (type === 'feather' && name === 'shuffle') {
    return import('react-feather/dist/icons/shuffle');
  }

  if (type === 'feather' && name === 'square') {
    return import('react-feather/dist/icons/square');
  }

  if (type === 'brand' && name === 'jupiterone/class/Host') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Host');
  }

  if (type === 'brand' && name === 'jupiterone/class/HostAgent') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/HostAgent');
  }

  if (type === 'feather' && name === 'cpu') {
    return import('react-feather/dist/icons/cpu');
  }

  if (type === 'feather' && name === 'alert-triangle') {
    return import('react-feather/dist/icons/alert-triangle');
  }

  if (type === 'feather' && name === 'link-2') {
    return import('react-feather/dist/icons/link-2');
  }

  if (type === 'feather' && name === 'globe') {
    return import('react-feather/dist/icons/globe');
  }

  if (type === 'feather' && name === 'navigation-2') {
    return import('react-feather/dist/icons/navigation-2');
  }

  if (type === 'brand' && name === 'jupiterone/class/Key') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Key');
  }

  if (type === 'feather' && name === 'voicemail') {
    return import('react-feather/dist/icons/voicemail');
  }

  if (type === 'feather' && name === 'package') {
    return import('react-feather/dist/icons/package');
  }

  if (type === 'feather' && name === 'triangle') {
    return import('react-feather/dist/icons/triangle');
  }

  if (type === 'feather' && name === 'share-2') {
    return import('react-feather/dist/icons/share-2');
  }

  if (type === 'brand' && name === 'jupiterone/class/NetworkEndpoint') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/NetworkEndpoint'
    );
  }

  if (type === 'feather' && name === 'link-2') {
    return import('react-feather/dist/icons/link-2');
  }

  if (type === 'brand' && name === 'jupiterone/class/Organization') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/Organization'
    );
  }

  if (type === 'brand' && name === 'jupiterone/class/PasswordPolicy') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/PasswordPolicy'
    );
  }

  if (type === 'feather' && name === 'user') {
    return import('react-feather/dist/icons/user');
  }

  if (type === 'feather' && name === 'file-text') {
    return import('react-feather/dist/icons/file-text');
  }

  if (type === 'feather' && name === 'git-pull-request') {
    return import('react-feather/dist/icons/git-pull-request');
  }

  if (type === 'brand' && name === 'jupiterone/class/Procedure') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Procedure');
  }

  if (type === 'feather' && name === 'shopping-bag') {
    return import('react-feather/dist/icons/shopping-bag');
  }

  if (type === 'feather' && name === 'umbrella') {
    return import('react-feather/dist/icons/umbrella');
  }

  if (type === 'feather' && name === 'folder') {
    return import('react-feather/dist/icons/folder');
  }

  if (type === 'feather' && name === 'shuffle') {
    return import('react-feather/dist/icons/shuffle');
  }

  if (type === 'feather' && name === 'loader') {
    return import('react-feather/dist/icons/loader');
  }

  if (type === 'feather' && name === 'fast-forward') {
    return import('react-feather/dist/icons/fast-forward');
  }

  if (type === 'feather' && name === 'file') {
    return import('react-feather/dist/icons/file');
  }

  if (type === 'brand' && name === 'jupiterone/class/Repository') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Repository');
  }

  if (type === 'feather' && name === 'list') {
    return import('react-feather/dist/icons/list');
  }

  if (type === 'feather' && name === 'battery') {
    return import('react-feather/dist/icons/battery');
  }

  if (type === 'brand' && name === 'jupiterone/class/ResourceGroup') {
    return import(
      '@jupiterone/react-brand-icons/jupiterone/class/ResourceGroup'
    );
  }

  if (type === 'feather' && name === 'thumbs-up') {
    return import('react-feather/dist/icons/thumbs-up');
  }

  if (type === 'feather' && name === 'alert-octagon') {
    return import('react-feather/dist/icons/alert-octagon');
  }

  if (type === 'feather' && name === 'award') {
    return import('react-feather/dist/icons/award');
  }

  if (type === 'brand' && name === 'jupiterone/class/Root') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Root');
  }

  if (type === 'feather' && name === 'check-circle') {
    return import('react-feather/dist/icons/check-circle');
  }

  if (type === 'brand' && name === 'jupiterone/class/Ruleset') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Ruleset');
  }

  if (type === 'feather' && name === 'life-buoy') {
    return import('react-feather/dist/icons/life-buoy');
  }

  if (type === 'brand' && name === 'jupiterone/class/Secret') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Secret');
  }

  if (type === 'feather' && name === 'cloud') {
    return import('react-feather/dist/icons/cloud');
  }

  if (type === 'feather' && name === 'map-pin') {
    return import('react-feather/dist/icons/map-pin');
  }

  if (type === 'feather' && name === 'rss') {
    return import('react-feather/dist/icons/rss');
  }

  if (type === 'feather' && name === 'clock') {
    return import('react-feather/dist/icons/clock');
  }

  if (type === 'feather' && name === 'users') {
    return import('react-feather/dist/icons/users');
  }

  if (type === 'brand' && name === 'jupiterone/class/Training') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Training');
  }

  if (type === 'brand' && name === 'jupiterone/class/User') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/User');
  }

  if (type === 'brand' && name === 'jupiterone/class/UserGroup') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/UserGroup');
  }

  if (type === 'feather' && name === 'briefcase') {
    return import('react-feather/dist/icons/briefcase');
  }

  if (type === 'feather' && name === 'shield-off') {
    return import('react-feather/dist/icons/shield-off');
  }

  if (type === 'brand' && name === 'jupiterone/class/Weakness') {
    return import('@jupiterone/react-brand-icons/jupiterone/class/Weakness');
  }

  if (type === 'feather' && name === 'truck') {
    return import('react-feather/dist/icons/truck');
  }

  if (type === 'feather' && name === 'target') {
    return import('react-feather/dist/icons/target');
  }

  if (type === 'feather' && name === 'user') {
    return import('react-feather/dist/icons/user');
  }

  if (type === 'feather' && name === 'globe') {
    return import('react-feather/dist/icons/globe');
  }

  if (type === 'feather' && name === 'smartphone') {
    return import('react-feather/dist/icons/smartphone');
  }

  if (type === 'feather' && name === 'monitor') {
    return import('react-feather/dist/icons/monitor');
  }

  if (type === 'aws' && name === 'security/MFAToken') {
    return import('react-aws-icons/dist/aws/security/MFAToken');
  }

  if (type === 'brand' && name === 'aws/logo') {
    return import('@jupiterone/react-brand-icons/aws/logo');
  }

  if (type === 'aws' && name === 'compute/AWSCloud') {
    return import('react-aws-icons/dist/aws/compute/AWSCloud');
  }

  if (type === 'aws' && name === 'logo/ACM') {
    return import('react-aws-icons/dist/aws/logo/ACM');
  }

  if (type === 'aws' && name === 'logo/APIGateway') {
    return import('react-aws-icons/dist/aws/logo/APIGateway');
  }

  if (type === 'aws' && name === 'logo/AppStream') {
    return import('react-aws-icons/dist/aws/logo/AppStream');
  }

  if (type === 'aws' && name === 'logo/Athena') {
    return import('react-aws-icons/dist/aws/logo/Athena');
  }

  if (type === 'aws' && name === 'compute/AutoScaling') {
    return import('react-aws-icons/dist/aws/compute/AutoScaling');
  }

  if (type === 'aws' && name === 'compute/AutoScaling') {
    return import('react-aws-icons/dist/aws/compute/AutoScaling');
  }

  if (type === 'aws' && name === 'logo/Batch') {
    return import('react-aws-icons/dist/aws/logo/Batch');
  }

  if (type === 'aws' && name === 'logo/Chime') {
    return import('react-aws-icons/dist/aws/logo/Chime');
  }

  if (type === 'aws' && name === 'logo/CloudDirectory') {
    return import('react-aws-icons/dist/aws/logo/CloudDirectory');
  }

  if (type === 'aws' && name === 'logo/CloudFormation') {
    return import('react-aws-icons/dist/aws/logo/CloudFormation');
  }

  if (type === 'aws' && name === 'logo/CloudFront') {
    return import('react-aws-icons/dist/aws/logo/CloudFront');
  }

  if (type === 'aws' && name === 'logo/CloudHSM') {
    return import('react-aws-icons/dist/aws/logo/CloudHSM');
  }

  if (type === 'aws' && name === 'logo/CloudSearch') {
    return import('react-aws-icons/dist/aws/logo/CloudSearch');
  }

  if (type === 'aws' && name === 'logo/CloudTrail') {
    return import('react-aws-icons/dist/aws/logo/CloudTrail');
  }

  if (type === 'aws' && name === 'logo/CloudWatch') {
    return import('react-aws-icons/dist/aws/logo/CloudWatch');
  }

  if (type === 'aws' && name === 'logo/CodeBuild') {
    return import('react-aws-icons/dist/aws/logo/CodeBuild');
  }

  if (type === 'aws' && name === 'logo/CodeCommit') {
    return import('react-aws-icons/dist/aws/logo/CodeCommit');
  }

  if (type === 'aws' && name === 'logo/CodeDeploy') {
    return import('react-aws-icons/dist/aws/logo/CodeDeploy');
  }

  if (type === 'aws' && name === 'logo/CodePipeline') {
    return import('react-aws-icons/dist/aws/logo/CodePipeline');
  }

  if (type === 'aws' && name === 'logo/CodeStar') {
    return import('react-aws-icons/dist/aws/logo/CodeStar');
  }

  if (type === 'aws' && name === 'logo/Cognito') {
    return import('react-aws-icons/dist/aws/logo/Cognito');
  }

  if (type === 'aws' && name === 'logo/Cognito') {
    return import('react-aws-icons/dist/aws/logo/Cognito');
  }

  if (type === 'aws' && name === 'logo/Config') {
    return import('react-aws-icons/dist/aws/logo/Config');
  }

  if (type === 'aws' && name === 'logo/Connect') {
    return import('react-aws-icons/dist/aws/logo/Connect');
  }

  if (type === 'aws' && name === 'logo/DataPipeline') {
    return import('react-aws-icons/dist/aws/logo/DataPipeline');
  }

  if (type === 'aws' && name === 'logo/DeviceFarm') {
    return import('react-aws-icons/dist/aws/logo/DeviceFarm');
  }

  if (type === 'aws' && name === 'logo/DirectConnect') {
    return import('react-aws-icons/dist/aws/logo/DirectConnect');
  }

  if (type === 'aws' && name === 'logo/DirectoryService') {
    return import('react-aws-icons/dist/aws/logo/DirectoryService');
  }

  if (type === 'aws' && name === 'logo/DynamoDB') {
    return import('react-aws-icons/dist/aws/logo/DynamoDB');
  }

  if (type === 'aws' && name === 'logo/DynamoDB') {
    return import('react-aws-icons/dist/aws/logo/DynamoDB');
  }

  if (type === 'aws' && name === 'logo/DMS') {
    return import('react-aws-icons/dist/aws/logo/DMS');
  }

  if (type === 'aws' && name === 'logo/EC2') {
    return import('react-aws-icons/dist/aws/logo/EC2');
  }

  if (type === 'aws' && name === 'logo/VPC') {
    return import('react-aws-icons/dist/aws/logo/VPC');
  }

  if (type === 'aws' && name === 'compute/ECR') {
    return import('react-aws-icons/dist/aws/compute/ECR');
  }

  if (type === 'aws' && name === 'logo/ECS') {
    return import('react-aws-icons/dist/aws/logo/ECS');
  }

  if (type === 'aws' && name === 'logo/EFS') {
    return import('react-aws-icons/dist/aws/logo/EFS');
  }

  if (type === 'aws' && name === 'logo/ELB') {
    return import('react-aws-icons/dist/aws/logo/ELB');
  }

  if (type === 'aws' && name === 'logo/EMR') {
    return import('react-aws-icons/dist/aws/logo/EMR');
  }

  if (type === 'aws' && name === 'logo/ES') {
    return import('react-aws-icons/dist/aws/logo/ES');
  }

  if (type === 'aws' && name === 'logo/ElasticBeanstalk') {
    return import('react-aws-icons/dist/aws/logo/ElasticBeanstalk');
  }

  if (type === 'aws' && name === 'logo/ElasticCache') {
    return import('react-aws-icons/dist/aws/logo/ElasticCache');
  }

  if (type === 'aws' && name === 'logo/ElasticTranscoder') {
    return import('react-aws-icons/dist/aws/logo/ElasticTranscoder');
  }

  if (type === 'aws' && name === 'compute/KinesisFirehose') {
    return import('react-aws-icons/dist/aws/compute/KinesisFirehose');
  }

  if (type === 'aws' && name === 'logo/GameList') {
    return import('react-aws-icons/dist/aws/logo/GameList');
  }

  if (type === 'aws' && name === 'logo/Glacier') {
    return import('react-aws-icons/dist/aws/logo/Glacier');
  }

  if (type === 'aws' && name === 'logo/Glue') {
    return import('react-aws-icons/dist/aws/logo/Glue');
  }

  if (type === 'aws' && name === 'logo/Greengrass') {
    return import('react-aws-icons/dist/aws/logo/Greengrass');
  }

  if (type === 'aws' && name === 'logo/IAM') {
    return import('react-aws-icons/dist/aws/logo/IAM');
  }

  if (type === 'aws' && name === 'logo/Inspector') {
    return import('react-aws-icons/dist/aws/logo/Inspector');
  }

  if (type === 'aws' && name === 'logo/IoT') {
    return import('react-aws-icons/dist/aws/logo/IoT');
  }

  if (type === 'aws' && name === 'logo/KMS') {
    return import('react-aws-icons/dist/aws/logo/KMS');
  }

  if (type === 'aws' && name === 'logo/Kinesis') {
    return import('react-aws-icons/dist/aws/logo/Kinesis');
  }

  if (type === 'aws' && name === 'logo/Kinesis') {
    return import('react-aws-icons/dist/aws/logo/Kinesis');
  }

  if (type === 'aws' && name === 'logo/Lambda') {
    return import('react-aws-icons/dist/aws/logo/Lambda');
  }

  if (type === 'aws' && name === 'logo/Lex') {
    return import('react-aws-icons/dist/aws/logo/Lex');
  }

  if (type === 'aws' && name === 'logo/Lightsail') {
    return import('react-aws-icons/dist/aws/logo/Lightsail');
  }

  if (type === 'aws' && name === 'logo/MachineLearning') {
    return import('react-aws-icons/dist/aws/logo/MachineLearning');
  }

  if (type === 'aws' && name === 'logo/Macie') {
    return import('react-aws-icons/dist/aws/logo/Macie');
  }

  if (type === 'aws' && name === 'logo/ManagedServices') {
    return import('react-aws-icons/dist/aws/logo/ManagedServices');
  }

  if (type === 'aws' && name === 'logo/MechanicalTurk') {
    return import('react-aws-icons/dist/aws/logo/MechanicalTurk');
  }

  if (type === 'aws' && name === 'logo/MigrationHub') {
    return import('react-aws-icons/dist/aws/logo/MigrationHub');
  }

  if (type === 'aws' && name === 'logo/MobileAnalytics') {
    return import('react-aws-icons/dist/aws/logo/MobileAnalytics');
  }

  if (type === 'aws' && name === 'logo/MobileHub') {
    return import('react-aws-icons/dist/aws/logo/MobileHub');
  }

  if (type === 'aws' && name === 'logo/OpsWorks') {
    return import('react-aws-icons/dist/aws/logo/OpsWorks');
  }

  if (type === 'aws' && name === 'logo/Organizations') {
    return import('react-aws-icons/dist/aws/logo/Organizations');
  }

  if (type === 'aws' && name === 'logo/Pinpoint') {
    return import('react-aws-icons/dist/aws/logo/Pinpoint');
  }

  if (type === 'aws' && name === 'logo/Polly') {
    return import('react-aws-icons/dist/aws/logo/Polly');
  }

  if (type === 'aws' && name === 'logo/QuickSight') {
    return import('react-aws-icons/dist/aws/logo/QuickSight');
  }

  if (type === 'aws' && name === 'logo/RDS') {
    return import('react-aws-icons/dist/aws/logo/RDS');
  }

  if (type === 'aws' && name === 'logo/Redshift') {
    return import('react-aws-icons/dist/aws/logo/Redshift');
  }

  if (type === 'aws' && name === 'logo/Rekognition') {
    return import('react-aws-icons/dist/aws/logo/Rekognition');
  }

  if (type === 'aws' && name === 'logo/Route53') {
    return import('react-aws-icons/dist/aws/logo/Route53');
  }

  if (type === 'aws' && name === 'logo/S3') {
    return import('react-aws-icons/dist/aws/logo/S3');
  }

  if (type === 'aws' && name === 'logo/SES') {
    return import('react-aws-icons/dist/aws/logo/SES');
  }

  if (type === 'aws' && name === 'logo/SMS') {
    return import('react-aws-icons/dist/aws/logo/SMS');
  }

  if (type === 'aws' && name === 'logo/SNS') {
    return import('react-aws-icons/dist/aws/logo/SNS');
  }

  if (type === 'aws' && name === 'logo/SQS') {
    return import('react-aws-icons/dist/aws/logo/SQS');
  }

  if (type === 'aws' && name === 'logo/SWF') {
    return import('react-aws-icons/dist/aws/logo/SWF');
  }

  if (type === 'aws' && name === 'logo/ServiceCatalog') {
    return import('react-aws-icons/dist/aws/logo/ServiceCatalog');
  }

  if (type === 'aws' && name === 'logo/Shield') {
    return import('react-aws-icons/dist/aws/logo/Shield');
  }

  if (type === 'aws' && name === 'logo/Snowball') {
    return import('react-aws-icons/dist/aws/logo/Snowball');
  }

  if (type === 'aws' && name === 'logo/StepFunctions') {
    return import('react-aws-icons/dist/aws/logo/StepFunctions');
  }

  if (type === 'aws' && name === 'logo/StorageGateway') {
    return import('react-aws-icons/dist/aws/logo/StorageGateway');
  }

  if (type === 'aws' && name === 'logo/AWS') {
    return import('react-aws-icons/dist/aws/logo/AWS');
  }

  if (type === 'aws' && name === 'logo/SystemsManager') {
    return import('react-aws-icons/dist/aws/logo/SystemsManager');
  }

  if (type === 'aws' && name === 'logo/TrustedAdvisor') {
    return import('react-aws-icons/dist/aws/logo/TrustedAdvisor');
  }

  if (type === 'aws' && name === 'logo/WAF') {
    return import('react-aws-icons/dist/aws/logo/WAF');
  }

  if (type === 'aws' && name === 'work/Docs') {
    return import('react-aws-icons/dist/aws/work/Docs');
  }

  if (type === 'aws' && name === 'work/Mail') {
    return import('react-aws-icons/dist/aws/work/Mail');
  }

  if (type === 'aws' && name === 'work/Spaces') {
    return import('react-aws-icons/dist/aws/work/Spaces');
  }

  if (type === 'aws' && name === 'logo/XRay') {
    return import('react-aws-icons/dist/aws/logo/XRay');
  }

  if (type === 'aws' && name === 'security/ACM') {
    return import('react-aws-icons/dist/aws/security/ACM');
  }

  if (type === 'aws' && name === 'compute/LoadBalancer') {
    return import('react-aws-icons/dist/aws/compute/LoadBalancer');
  }

  if (type === 'aws' && name === 'manage/Stack') {
    return import('react-aws-icons/dist/aws/manage/Stack');
  }

  if (type === 'aws' && name === 'manage/Deployments') {
    return import('react-aws-icons/dist/aws/manage/Deployments');
  }

  if (type === 'aws' && name === 'manage/EventTimeBased') {
    return import('react-aws-icons/dist/aws/manage/EventTimeBased');
  }

  if (type === 'aws' && name === 'db/Table') {
    return import('react-aws-icons/dist/aws/db/Table');
  }

  if (type === 'aws' && name === 'compute/AMI') {
    return import('react-aws-icons/dist/aws/compute/AMI');
  }

  if (type === 'aws' && name === 'compute/Instance') {
    return import('react-aws-icons/dist/aws/compute/Instance');
  }

  if (type === 'aws' && name === 'compute/InternetGateway') {
    return import('react-aws-icons/dist/aws/compute/InternetGateway');
  }

  if (type === 'aws' && name === 'compute/AccessControlList') {
    return import('react-aws-icons/dist/aws/compute/AccessControlList');
  }

  if (type === 'aws' && name === 'compute/Endpoints') {
    return import('react-aws-icons/dist/aws/compute/Endpoints');
  }

  if (type === 'aws' && name === 'compute/VPCSubnet') {
    return import('react-aws-icons/dist/aws/compute/VPCSubnet');
  }

  if (type === 'aws' && name === 'storage/Volume') {
    return import('react-aws-icons/dist/aws/storage/Volume');
  }

  if (type === 'aws' && name === 'compute/VPC') {
    return import('react-aws-icons/dist/aws/compute/VPC');
  }

  if (type === 'aws' && name === 'compute/Registry') {
    return import('react-aws-icons/dist/aws/compute/Registry');
  }

  if (type === 'aws' && name === 'compute/Container') {
    return import('react-aws-icons/dist/aws/compute/Container');
  }

  if (type === 'aws' && name === 'db/Memcached') {
    return import('react-aws-icons/dist/aws/db/Memcached');
  }

  if (type === 'aws' && name === 'db/Redis') {
    return import('react-aws-icons/dist/aws/db/Redis');
  }

  if (type === 'aws' && name === 'db/Cache') {
    return import('react-aws-icons/dist/aws/db/Cache');
  }

  if (type === 'aws' && name === 'compute/SearchDocuments') {
    return import('react-aws-icons/dist/aws/compute/SearchDocuments');
  }

  if (type === 'aws' && name === 'security/IAM') {
    return import('react-aws-icons/dist/aws/security/IAM');
  }

  if (type === 'aws' && name === 'security/Permissions') {
    return import('react-aws-icons/dist/aws/security/Permissions');
  }

  if (type === 'aws' && name === 'manage/ChecklistSecurity') {
    return import('react-aws-icons/dist/aws/manage/ChecklistSecurity');
  }

  if (type === 'aws' && name === 'security/Role') {
    return import('react-aws-icons/dist/aws/security/Role');
  }

  if (type === 'aws' && name === 'security/Permissions') {
    return import('react-aws-icons/dist/aws/security/Permissions');
  }

  if (type === 'aws' && name === 'general/Users') {
    return import('react-aws-icons/dist/aws/general/Users');
  }

  if (type === 'aws' && name === 'security/Permissions') {
    return import('react-aws-icons/dist/aws/security/Permissions');
  }

  if (type === 'aws' && name === 'general/User') {
    return import('react-aws-icons/dist/aws/general/User');
  }

  if (type === 'aws' && name === 'security/Permissions') {
    return import('react-aws-icons/dist/aws/security/Permissions');
  }

  if (type === 'aws' && name === 'security/DataEncryptionKey') {
    return import('react-aws-icons/dist/aws/security/DataEncryptionKey');
  }

  if (type === 'aws' && name === 'compute/LambdaFunction') {
    return import('react-aws-icons/dist/aws/compute/LambdaFunction');
  }

  if (type === 'aws' && name === 'storage/Bucket') {
    return import('react-aws-icons/dist/aws/storage/Bucket');
  }

  if (type === 'aws' && name === 'message/Worker') {
    return import('react-aws-icons/dist/aws/message/Worker');
  }

  if (type === 'aws' && name === 'message/Topic') {
    return import('react-aws-icons/dist/aws/message/Topic');
  }

  if (type === 'aws' && name === 'message/Queue') {
    return import('react-aws-icons/dist/aws/message/Queue');
  }

  if (type === 'aws' && name === 'compute/HDFSCluster') {
    return import('react-aws-icons/dist/aws/compute/HDFSCluster');
  }

  if (type === 'aws' && name === 'compute/Cluster') {
    return import('react-aws-icons/dist/aws/compute/Cluster');
  }

  if (type === 'aws' && name === 'compute/DB') {
    return import('react-aws-icons/dist/aws/compute/DB');
  }

  if (type === 'aws' && name === 'compute/AppLoadBalancer') {
    return import('react-aws-icons/dist/aws/compute/AppLoadBalancer');
  }

  if (type === 'aws' && name === 'compute/LoadBalancer') {
    return import('react-aws-icons/dist/aws/compute/LoadBalancer');
  }

  if (type === 'aws' && name === 'compute/LoadBalancer') {
    return import('react-aws-icons/dist/aws/compute/LoadBalancer');
  }

  if (type === 'aws' && name === 'compute/LoadBalancer') {
    return import('react-aws-icons/dist/aws/compute/LoadBalancer');
  }

  if (type === 'aws' && name === 'manage/Permissions') {
    return import('react-aws-icons/dist/aws/manage/Permissions');
  }

  if (type === 'brand' && name === 'atlassian/logo') {
    return import('@jupiterone/react-brand-icons/atlassian/logo');
  }

  if (type === 'brand' && name === 'aui/folder') {
    return import('@jupiterone/react-brand-icons/aui/folder');
  }

  if (type === 'brand' && name === 'aui/repository') {
    return import('@jupiterone/react-brand-icons/aui/repository');
  }

  if (type === 'brand' && name === 'atlassian/bitbucket') {
    return import('@jupiterone/react-brand-icons/atlassian/bitbucket');
  }

  if (type === 'brand' && name === 'aui/person') {
    return import('@jupiterone/react-brand-icons/aui/person');
  }

  if (type === 'brand' && name === 'aui/pull-request') {
    return import('@jupiterone/react-brand-icons/aui/pull-request');
  }

  if (type === 'brand' && name === 'octicons/logo-github') {
    return import('@jupiterone/react-brand-icons/octicons/logo-github');
  }

  if (type === 'brand' && name === 'octicons/mark-github') {
    return import('@jupiterone/react-brand-icons/octicons/mark-github');
  }

  if (type === 'brand' && name === 'octicons/mark-github') {
    return import('@jupiterone/react-brand-icons/octicons/mark-github');
  }

  if (type === 'brand' && name === 'octicons/repo') {
    return import('@jupiterone/react-brand-icons/octicons/repo');
  }

  if (type === 'brand' && name === 'octicons/jersey') {
    return import('@jupiterone/react-brand-icons/octicons/jersey');
  }

  if (type === 'brand' && name === 'octicons/person') {
    return import('@jupiterone/react-brand-icons/octicons/person');
  }

  if (type === 'brand' && name === 'atlassian/jira') {
    return import('@jupiterone/react-brand-icons/atlassian/jira');
  }

  if (type === 'brand' && name === 'aui/person-circle') {
    return import('@jupiterone/react-brand-icons/aui/person-circle');
  }

  if (type === 'brand' && name === 'aui/issue') {
    return import('@jupiterone/react-brand-icons/aui/issue');
  }

  if (type === 'brand' && name === 'aui/folder') {
    return import('@jupiterone/react-brand-icons/aui/folder');
  }

  if (type === 'brand' && name === 'aui/person') {
    return import('@jupiterone/react-brand-icons/aui/person');
  }

  if (type === 'brand' && name === 'okta/logo') {
    return import('@jupiterone/react-brand-icons/okta/logo');
  }

  if (type === 'brand' && name === 'okta/icon') {
    return import('@jupiterone/react-brand-icons/okta/icon');
  }

  if (type === 'brand' && name === 'sentinelone/icon') {
    return import('@jupiterone/react-brand-icons/sentinelone/icon');
  }

  if (type === 'feather' && name === 'circle') {
    return import('react-feather/dist/icons/circle');
  }

  throw new Error(`Failed to load icon with type "${type}" and name "${name}"`);
}
